.color-success svg {
  color: var(--rc-theme-color-success-default);
}

.color-primary svg {
  color: var(--rc-theme-color-primary-default);
}

.color-error svg {
  color: var(--rc-theme-color-error-default);
}

.color-info svg {
  color: var(--rc-theme-color-info-default);
}

.color-placeholder svg {
  color: var(--rc-theme-color-text-placeholder);
}

.color-text svg {
  color: var(--rc-theme-color-text-default);
}

.color-secondary svg {
  color: var(--rc-theme-color-text-secondary);
}

.color-warning svg {
  color: var(--rc-theme-color-warning-default);
}

/* TODO: size variables */
.size-small {
  font-size: var(--rc-theme-font-size-text-lg);
}

.size-medium-small {
  font-size: 20px;
}

.size-middle {
  font-size: 24px;
}

.size-large {
  font-size: 40px;
}

.size-extra-small {
  font-size: var(--rc-theme-font-size-text-base);
}

.size-extra-extra-small {
  font-size: var(--rc-theme-font-size-text-sm);
}

.background-white svg {
  background: var(--rc-theme-color-surface-default);
}

.shape-circle svg {
  border-radius: 50%;
}

.spin {
  display: inline-block;
  animation: icon-spin 1s linear infinite;
}

@keyframes icon-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .spin {
    animation: none;
  }
}
